import API from '@/utils/API';
import {
  IProposal,
  IListGrantsParams,
  IGetCompanyGrantParams,
  ICompanyGrant
} from '@/types/API';

export const getListGrants = (variables: IListGrantsParams) => {
  const query = /* GraphQL */ `
    query listGrants(
      $assetId: String
      $companyId: String
      $userId: String
      $limit: Int
      $nextToken: String
    ) {
      listGrants(
        assetId: $assetId
        companyId: $companyId
        userId: $userId
        limit: $limit
        nextToken: $nextToken
      ) {
        items {
          status
          access
          assetId
          user {
            email
            firstName
            lastName
          }
          userId
          companyId
          company {
            name
            domain
            id
            logo {
              thumbnail
              type
              url
              name
            }
          }
          companyGrant {
            assetId
            companyId
            company {
              name
              domain
              id
              logo {
                thumbnail
                type
                url
                name
              }
            }
            conflictCheck {
              userId
              user {
                email
                firstName
                lastName
              }
              updatedAt
            }
            preBid {
              userId
              user {
                email
                firstName
                lastName
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        count
        nextToken
      }
    }
  `;

  return API.graphql<IProposal>('asset', {
    query,
    variables
  });
};

export const getCompanyGrant = (variables: IGetCompanyGrantParams) => {
  const query = `
          query getCompanyGrant($assetId: String!, $companyId: String) {
            getCompanyGrant(assetId: $assetId, companyId: $companyId) {
              assetId
              companyId
              createdAt
              updatedAt
              company {
                name
                domain
                id
              }
              conflictCheck {
                userId
                updatedAt
              }
              draftPreBid {
                userId
                updatedAt
              }
              preBid  {
                userId
                updatedAt
              }
            }
          }
      `;

  return API.graphql<ICompanyGrant>('asset', {
    query,
    variables
  });
};
